interface VideoDisplayProps extends React.HTMLAttributes<HTMLVideoElement> {
  ref?: React.Ref<HTMLVideoElement>
}

export const VideoDisplay = (props: VideoDisplayProps) => {
  return (
    <video autoPlay={true} {...props}>
      <track kind="captions" src="" srcLang="en" label="English" />
    </video>
  )
}
